//@ts-ignore
import React, { useState, useEffect } from "react";
import _ from "lodash";
import cx from 'classnames';
import { CHANGE_LABEL, CHANGE_TYPE, CONTENT_LOCATION, COURSE_CHANGE, PACKAGE_CHANGE_TYPE, REQUEST_CHANGES, REQUEST_PLACEHOLDER } from "../../../../../Constants/constants";
import { COURSE_CHANGE_TAB } from "../../../../../types/enums/RequestStatus";
import { getImageSource } from "../../../../../helpers/helpers";
import { convertDateToHHMM, convertDaysToReadableFormat, formatDateToDayMonthYear, getLabel, formatDateToDayMonthYearGB } from "../../../../../../../utils";
import { contentManagementService } from "../../../../../service";
import './HistoryDetail.css';
import { HISTORY_TYPE, PHASE_ACTIVITY_STATUS } from "../../../../../../../constants/comman";

interface HistoryDetailProps {
    history: any,
}

const HistoryDetail = (props: HistoryDetailProps) => {
    const [activeTab, setActiveTab] = useState(0);
    const [coursePlanId, setCoursePlanId] = useState('');
    const [updatedDate, setUpdatedDate] = useState('');
    const [coursePlanChanges, setCoursePlanChanges] = useState({});
    const dateChanges = [CHANGE_TYPE.START_DATE, CHANGE_TYPE.END_DATE, CHANGE_TYPE.IS_ACTIVE];
    const businessTypes = [CHANGE_TYPE.AVAILABLE_FOR_CRP, CHANGE_TYPE.AVAILABLE_FOR_NCRP];
    const requestId = (window.location.href).toString().split('/').pop();
    const changesKeys = Object.values(REQUEST_CHANGES);
    useEffect(() => {
        requestId &&
            contentManagementService.getCourseHistory(requestId).then((res: any) => {
                setUpdatedDate(res.coursePlanChanges.updatedAt || '');
                setChangesDetails(res.coursePlanChanges || {});
            })
    }, []);

    const getDefaultChange = () => {
        const requestChanges: any = {};
        changesKeys.forEach(changeProperty => {
            requestChanges[changeProperty] = [];
        });
        return requestChanges;
    }

    const populateDiff = (changes: any, changeType: any) => {
        (changes || []).forEach((change: any) => {
            changeType.push(change);
        });
    }

    const setChangesDetails = (changesDetails: any) => {
        setCoursePlanId(changesDetails.coursePlanId);
        const newRequestChanges = getDefaultChange();
        switch (changesDetails.requestType) {
            case HISTORY_TYPE.CHANGES_BULK_OPERATION:
                (changesDetails.bulkOperationDiffs.coursePlanChanges || []).forEach((change: any) => {
                    newRequestChanges[change.changeType].push(change);
                });
                populateDiff(changesDetails.bulkOperationDiffs.otherInfoChanges, newRequestChanges[REQUEST_CHANGES.OTHER]);
                break;
            case HISTORY_TYPE.EDITED_PUBLISHED_DIRECTLY:
                (changesDetails.publishedChanges.coursePlanChanges || []).forEach((change: any) => {
                    newRequestChanges[change.changeType].push(change);
                });
                populateDiff(changesDetails.publishedChanges.otherInfoChanges, newRequestChanges[REQUEST_CHANGES.OTHER]);
                populateDiff(changesDetails.publishedChanges.advancedSettingChanges, newRequestChanges[REQUEST_CHANGES.ADVANCE]);
                break;
            default:
                populateDiff(changesDetails.requestedChanges.dateChanges, newRequestChanges[REQUEST_CHANGES.DATE_CHANGE]);
                populateDiff(changesDetails.requestedChanges.reorderedChanges, newRequestChanges[REQUEST_CHANGES.REORDER]);
        }
        const index = changesKeys.findIndex(change => newRequestChanges[change].length > 0);
        (index !== -1) && setActiveTab(index);
        setCoursePlanChanges(newRequestChanges);
    }

    const handleTabClick = (tabIndex: number) => {
        if (tabIndex !== activeTab) {
            setActiveTab(tabIndex);
        }
    };

    const goBack = () => {
        props.history.goBack();
    }

    const getAdminName = (adminList: any[]) => {
        return (adminList || []).map((adminDetails: any) => adminDetails.fullName).join(',');
    }

    const getCourseName = (change: any) => {
        return (<li>
            <h2 className='phaseTitle'>Course Name</h2>
            <div className='paraSection'>
                <span className='iconCol'><img src='/assets/svg/course-plan-request/course-ic.svg' alt='Course' /></span>
                <p>{change.proposedChange}</p>
            </div>
            <p className='otherInfo'>Previously Course Name : {change.currentValue} </p>
        </li>);
    }

    const getCourseStartDate = (change: any) => {
        return (<li>
            <h2 className='phaseTitle'>Course Start Date</h2>
            <div className='paraSection'>
                <span className='iconCol'><img src='/assets/svg/course-plan-request/calendar-green-ic.svg' alt='Calendar' /></span>
                <p>{formatDateToDayMonthYear(change.proposedChange)}</p>
            </div>
            <p className='otherInfo'>Previously Course Start Date :  {formatDateToDayMonthYear(change.currentValue)}</p>
        </li>);
    }

    const getCourseEndDate = (change: any) => {
        return (<li>
            <h2 className='phaseTitle'>Course End Date</h2>
            <div className='paraSection'>
                <span className='iconCol'><img src='/assets/svg/course-plan-request/calendar-red-ic.svg' alt='Calendar' /></span>
                <p>{formatDateToDayMonthYear(change.proposedChange)}</p>
            </div>
            <p className='otherInfo'>Previously Course End Date :  {formatDateToDayMonthYear(change.currentValue)}</p>
        </li>);
    }

    const getCourseAdminName = (change: any) => {
        const proposedChange = getAdminName(change.proposedChange);
        const currentValue = getAdminName(change.currentValue);

        return (<li>
            <h2 className='phaseTitle'>Admin Name</h2>
            <div className='paraSection'>
                <span className='iconCol'><img src='/assets/svg/course-plan-request/admin-ic.svg' alt='Admin' /></span>
                <p>{(proposedChange)}</p>
            </div>
            <p className='otherInfo'>Previously Admin Name : {currentValue}</p>
        </li>);
    }

    const getCourseDuration = (change: any) => {
        return (<li>
            <h2 className='phaseTitle'>Course Duration</h2>
            <div className='paraSection'>
                <span className='iconCol'><img src='/assets/svg/course-plan-request/duration-ic.svg' alt='Duration' /></span>
                <p>{convertDaysToReadableFormat(change.proposedChange)} Course</p>
            </div>
            <p className='otherInfo'>Previously Course Duration : {convertDaysToReadableFormat(change.currentValue)} Course</p>
        </li>);
    }

    const getLastAddedContent = (path: any) => {
        let contentName = '';
        if (path.content) {
            contentName = path.content.name;
        } else if (path.concept) {
            contentName = path.concept.conceptName;
        } else if (path.chapter) {
            contentName = path.chapter.chapterName;
        } else if (path.subject) {
            contentName = path.subject.subjectName;
        } else if (path.week) {
            contentName = path.week.weekNo;
        } else if (path.phase) {
            contentName = path.phase.phaseNo;
        }
        return contentName;
    }

    const getBasicChange = (change: any) => {
        let basicChange = <></>;
        switch (change.changeType) {
            case CHANGE_TYPE.START_DATE:
                basicChange = getCourseStartDate(change);
                break;
            case CHANGE_TYPE.END_DATE:
                basicChange = getCourseEndDate(change);
                break;
            case CHANGE_TYPE.NAME_CHANGE:
                basicChange = getCourseName(change);
                break;
            case CHANGE_TYPE.DURATION_CHANGE:
                basicChange = getCourseDuration(change);
                break;
            case CHANGE_TYPE.ADMIN_NAME:
                basicChange = getCourseAdminName(change);
                break;
            default:
                basicChange = <></>;
        }

        return basicChange;
    }

    const getArrowPathName = (property: string, value: string, arrowNotVisible?: boolean) => {
        let pathName = <></>;
        if (value) {
            pathName = (<>
                {!arrowNotVisible &&
                    <img className='arrowIcon' src='/assets/svg/course-plan-request/arrow-ic.svg' alt='Left Arrow' />}
                {' '} {property} {value}
            </>);
        }
        return pathName;
    }

    const getCoursePlanChange = (change: any) => {
        const path = change.entityPath;
        if (!dateChanges.includes(change.changeType)) {
            return;
        }
        const phaseActivityDetail = {
            iconSrc: PHASE_ACTIVITY_STATUS.ACTIVE_ICON_SRC,
            displayText: PHASE_ACTIVITY_STATUS.ACTIVATED,
        }
        const displayDate = formatDateToDayMonthYearGB(updatedDate);
        if(change.currentValue && !change.proposedChange) {
            phaseActivityDetail.iconSrc = PHASE_ACTIVITY_STATUS.DEACTIVE_ICON_SRC;
            phaseActivityDetail.displayText = PHASE_ACTIVITY_STATUS.DEACTIVATED
        }
        if (change.changeType === CHANGE_TYPE.IS_ACTIVE) {
            return(
                <li>
                    {path && path.phase && 
                        <>
                            <div className="phase-status">
                                <span className="phase-heading">Phase {path.phase.phaseNo} <img src='/assets/svg/right-arrow.svg' alt='stage'/> Activation Status Changed</span>
                                <span className="iconCol">
                                    <img src={phaseActivityDetail.iconSrc} alt='Active' />
                                    {phaseActivityDetail.displayText}
                                </span>
                                <span className="sub-text">{phaseActivityDetail.displayText} On: {displayDate}</span>
                            </div>
                        </>
                    }
                </li>
            );
        }
        const isStartDateChanges = (change.changeType === CHANGE_TYPE.START_DATE);
        const imageUrl = isStartDateChanges ? CHANGE_LABEL.START_DATE.ICON : CHANGE_LABEL.END_DATE.ICON;
        const clockUrl = isStartDateChanges ? CHANGE_LABEL.START_DATE.CLOCK_ICON : CHANGE_LABEL.END_DATE.CLOCK_ICON
        return (<li>
            <div className='datePhaseTitle'>
                {path &&
                    <>
                        {path.content && <>
                            <span className='iconCol'>
                                <img src='/assets/svg/course-plan-request/test.svg' alt='Test' />
                            </span>
                            <p>{path.content.name || ''}  -</p>&nbsp;
                        </>
                        }
                        {getArrowPathName(CONTENT_LOCATION.PHASE, path.phase && path.phase.phaseNo, true)}
                        {getArrowPathName(CONTENT_LOCATION.WEEK, path.week && path.week.weekNo)}
                        {getArrowPathName(CONTENT_LOCATION.SUBJECT, path.subject && path.subject.subjectName)}
                        {getArrowPathName(CONTENT_LOCATION.CHAPTER, path.chapter && path.chapter.chapterName)}
                        {getArrowPathName(CONTENT_LOCATION.CONCEPT, path.concept && path.concept.conceptName)}
                    </>}&nbsp;
            </div>
            <div className='datePhaseLabel'>
                {getLabel(isStartDateChanges, !!(path.content))}
            </div>
            <div className='paraSection'>
                <span className='iconCol'>
                    <img src={imageUrl} alt='Calendar' />
                </span>
                <p>{formatDateToDayMonthYear(change.proposedChange)} </p>
                {path.content && <span className='iconCol'>
                    <img src={clockUrl} alt='Calendar' />
                </span>}
                <p>{path.content && convertDateToHHMM(change.proposedChange)}</p>
            </div>
            <p className='otherInfo'>Previously
                {(path && !path.content) && <>
                    {getArrowPathName(CONTENT_LOCATION.PHASE, path.phase.phaseNo, true)}
                    {getArrowPathName(CONTENT_LOCATION.WEEK, path.week && path.week.weekNo, true)}
                    {getArrowPathName(CONTENT_LOCATION.SUBJECT, path.subject && path.subject.subjectName, true)}
                    {getArrowPathName(CONTENT_LOCATION.CHAPTER, path.chapter && path.chapter.chapterName, true)}
                    {getArrowPathName(CONTENT_LOCATION.CONCEPT, path.concept && path.concept.conceptName, true)}
                </>}
                {(path && path.content) && <>
                    &nbsp;{isStartDateChanges ? CHANGE_LABEL.START_DATE.TEST_LABEL : CHANGE_LABEL.END_DATE.TEST_LABEL}
                </>}
                &nbsp;: {formatDateToDayMonthYear(change.currentValue)} {path.content && convertDateToHHMM(change.currentValue)}
            </p>
        </li>);
    }

    const getDateChanges = () => {
        const dateChanges = coursePlanChanges['date-change'] || [];
        return (<div className={cx('coursePlanRequestContent', { 'active': activeTab === COURSE_CHANGE_TAB.DATE_CHANGE })}>
            <h1 className='mainHeading'><strong>{dateChanges.length}</strong> new requests</h1>
            <div className='phaseBlockSection'>
                {!!dateChanges.length && <div className='phaseBlockCol'>
                    <ul className='phaseList'>
                        {
                            dateChanges.map((change: any) =>
                                getCoursePlanChange(change)
                            )
                        }
                    </ul>
                </div>}
            </div>
        </div>);
    }

    const getReorderChanges = () => {
        const reOrderChanges = coursePlanChanges[REQUEST_CHANGES.REORDER] || []
        return (<div className={cx('coursePlanRequestContent', { 'active': activeTab === COURSE_CHANGE_TAB.REORDERED })}>
            <h1 className='mainHeading'><strong>{reOrderChanges.length}</strong> new requests</h1>
            <div className='phaseBlockSection'>
                {reOrderChanges.map((change: any) => {
                    const oldPath = change.oldPath;
                    const newPath = change.newPath;
                    return <>
                        <div className='phaseBlockCol'>
                            <div className='phaseInfoGroup'>
                                <ul className='phaseInfo'>
                                    <li className='whiteSpaceNoWrap'>Phase: <strong>{newPath.phase && newPath.phase.phaseNo}</strong></li>
                                    <li className='whiteSpaceNoWrap'>Week: <strong>{newPath.week && newPath.week.weekNo}</strong></li>
                                    <li>{newPath.subject && newPath.subject.subjectName}</li>
                                    <li>{newPath.chapter && newPath.chapter.chapterName}</li>
                                    <li>{newPath.concept && newPath.concept.conceptName}</li>
                                </ul>
                                <ul className='phasePrevInfo'>
                                    <li className='whiteSpaceNoWrap'>Previously in : Phase: {oldPath.phase && oldPath.phase.phaseNo}</li>
                                    <li className='whiteSpaceNoWrap'>Week: {oldPath.week && oldPath.week.weekNo}</li>
                                    <li>{oldPath.subject && newPath.week.subjectName}</li>
                                    <li>{oldPath.chapter && oldPath.chapter.chapterName}</li>
                                    <li>{oldPath.concept && oldPath.concept.conceptName}</li>
                                </ul>
                            </div>
                            <ul className='phaseList'>
                                {(newPath.concept && newPath.concept.conceptName) || (newPath.chapter && newPath.chapter.chapterName)}
                            </ul>
                        </div>
                    </>
                })
                }
            </div>
        </div>);
    }

    const getEnabledDisabledLabel = (enabled: boolean) => {
        return enabled ? CHANGE_LABEL.ENABLED.LABEL : CHANGE_LABEL.DISABLED.LABEL;
    }

    const getPublishDetails = (change: any) => {
        if (!change || CHANGE_TYPE.GLORIFIRE_PUBLISH !== change.changeType) {
            return;
        }
        const enabled = change.proposedChange;
        const currentValue = change.currentValue;
        const imageUrl = enabled ? CHANGE_LABEL.ENABLED.ICON : CHANGE_LABEL.DISABLED.ICON;

        return (
            <li>
                <h2 className='phaseTitle'>Publish on glorifire.com</h2>
                <div className='paraSection'>
                    <span className='iconCol'><img src={imageUrl} alt='Glorifire Publish' /></span>
                    <p>{getEnabledDisabledLabel(enabled)}</p>
                </div>
                <p className='otherInfo'>Previously Publish on glorifire.com : {getEnabledDisabledLabel(currentValue)} </p>
            </li>);
    }

    const getTestUserDetails = (change: any) => {
        if (!change || CHANGE_TYPE.TEST_USER_PUBLISH !== change.changeType) {
            return;
        }
        const enabled = change.proposedChange;
        const currentValue = change.currentValue;
        const imageUrl = enabled ? CHANGE_LABEL.ENABLED.ICON : CHANGE_LABEL.DISABLED.ICON;
        return (
            <li>
                <h2 className='phaseTitle'>Publish for test users only</h2>
                <div className='paraSection'>
                    <span className='iconCol'><img src={imageUrl} alt='Disabled' /></span>
                    <p>{getEnabledDisabledLabel(enabled)}</p>
                </div>
                <p className='otherInfo'>Previously Publish for test users only : {getEnabledDisabledLabel(currentValue)}</p>
            </li>
        );
    }

    const getPaidFreeText = (paidCourse: any) => {
        return paidCourse ? CHANGE_LABEL.PAID.LABEL : CHANGE_LABEL.FREE.LABEL;
    }

    const getPriceDetails = (change: any) => {
        if (!change || change.changeType !== CHANGE_TYPE.COURSE_TYPE) {
            return;
        }
        const paidCourse = change.proposedChange;
        const currentValue = change.currentValue;
        const imageUrl = paidCourse ? CHANGE_LABEL.PAID.ICON : CHANGE_LABEL.FREE.ICON;

        return (<>
            <div className='paraSection'>
                <span className='iconCol'><img src={imageUrl} alt='Price' /></span>
                <p>{getPaidFreeText(change)}</p>
            </div>
            <p className='otherInfo'>Previously Course Type : {getPaidFreeText(currentValue)}</p>
        </>);
    }

    const getPriceChange = (change: any) => {
        if (!change || change.changeType !== CHANGE_TYPE.COURSE_PRICE) {
            return;
        }

        return (<>
            <h2 className='phaseSubTitle'>Course Price</h2>
            <div className='paraSection'>
                <span className='iconCol'><img src='/assets/svg/course-plan-request/currency-ic.svg' alt='Currency' /></span>
                <p> INR {change.proposedChange}</p>
            </div>
            <p className='otherInfo'>Previously Course Price : INR - {change.currentValue}</p>
        </>);
    }

    const getDiscountChange = (change: any) => {
        if (!change || change.changeType !== CHANGE_TYPE.DISCOUNT) {
            return;
        }
        const proposedChange = change.proposedChange;
        const currentValue = change.currentValue;
        const imageUrl = (proposedChange - currentValue) >= 0 ? CHANGE_LABEL.PERCENTAGE_INCREASE.ICON : CHANGE_LABEL.PERCENTAGE_INCREASE.ICON;

        return (<>
            <h2 className='phaseSubTitle'>Discount (%)</h2>
            <div className='paraSection'>
                <span className='iconCol'><img src={imageUrl} alt='discount' /></span>
                <p>{proposedChange}</p>
            </div>
            <p className='otherInfo'>Previously Discount : {currentValue}</p>
        </>
        );
    }

    const getMainTestInfoIconChange = (change: any) => {
        if (!change || change.changeType !== CHANGE_TYPE.MAIN_TEST_INFO_ICON) {
            return;
        }
        const proposedChange = change.proposedChange;
        const currentValue = change.currentValue;
        const imageUrl = CHANGE_LABEL.MAIN_INFO.ICON;

        return (<li>
            <h2 className='phaseTitle'>Main Test Info Icon Text</h2>
            <div className='paraSection'>
                <span className='iconCol'><img src={imageUrl} alt='Main Test' /></span>
                <p>{proposedChange}</p>
            </div>
            <p className='otherInfo'>Previously Main Test Info Icon Text : {currentValue}</p>
        </li>);
    }

    const getConceptTestInfo = (change: any) => {

        if (!change || change.changeType !== CHANGE_TYPE.CONCEPT_TEST_INFO_ICON) {
            return;
        }
        const proposedChange = change.proposedChange;
        const currentValue = change.currentValue;
        const imageUrl = CHANGE_LABEL.CONCEPT_INFO.ICON;

        return (<>
            <li>
                <h2 className='phaseTitle'>Concept Test Info Icon (Package Name)</h2>
                <div className='paraSection'>
                    <span className='iconCol'><img src={imageUrl} alt='Concept Test' /></span>
                    <p>{proposedChange}</p>
                </div>
                <p className='otherInfo'>Previously Concept Test Info Icon (Package Name) :{currentValue}</p>
            </li>
        </>);
    }

    const getYesNoText = (isYesLabel: boolean) => {
        return isYesLabel ? CHANGE_LABEL.YES : CHANGE_LABEL.NO;
    }

    const getAvailableBusinessType = (change: any, businessType: string) => {
        if (!change || !businessTypes.includes(change.changeType)) {
            return;
        }
        return (<li>
            <h2 className='phaseSubTitle'>Available For {businessType} :
                <span> {getYesNoText(change.proposedChange).LABEL}
                </span>
            </h2>
            <p className='otherInfo'>Previously Available For {businessType} : {getYesNoText(change.currentValue).LABEL}</p>
        </li>);
    }

    const getGeneralSetting = (generalSetting: any[]) => {
        if (!generalSetting.length) {
            return;
        }
        const publishChange = generalSetting.find(change => change.changeType === CHANGE_TYPE.GLORIFIRE_PUBLISH);
        const testChange = generalSetting.find(change => change.changeType === CHANGE_TYPE.TEST_USER_PUBLISH);
        const paidChange = generalSetting.find(change => change.changeType === CHANGE_TYPE.COURSE_TYPE);
        const priceChange = generalSetting.find(change => change.changeType === CHANGE_TYPE.COURSE_PRICE);
        const discountChange = generalSetting.find(change => change.changeType === CHANGE_TYPE.DISCOUNT);
        const mainTestIconChange = generalSetting.find(change => change.changeType === CHANGE_TYPE.MAIN_TEST_INFO_ICON);
        const conceptTestIconChange = generalSetting.find(change => change.changeType === CHANGE_TYPE.CONCEPT_TEST_INFO_ICON);
        const availableForCRP = generalSetting.find(change => change.changeType === CHANGE_TYPE.AVAILABLE_FOR_CRP);
        const availableForNCRP = generalSetting.find(change => change.changeType === CHANGE_TYPE.AVAILABLE_FOR_NCRP);
        const courseTypeVisible = paidChange || discountChange || priceChange;

        return (<div className='phaseBlockCol'>
            <ul className='phaseInfo'>
                <li>General Setting</li>
            </ul>
            <ul className='phaseList'>
                {getPublishDetails(publishChange)}
                {getTestUserDetails(testChange)}
                {courseTypeVisible && <li>
                    <h2 className='phaseTitle'>Course Type</h2>
                    {getPriceDetails(paidChange)}
                    {getPriceChange(priceChange)}
                    {getDiscountChange(discountChange)}
                </li>}
                {getMainTestInfoIconChange(mainTestIconChange)}
                {getConceptTestInfo(conceptTestIconChange)}
                {getAvailableBusinessType(availableForCRP, REQUEST_PLACEHOLDER.CRP.LABEL)}
                {getAvailableBusinessType(availableForNCRP, REQUEST_PLACEHOLDER.CRP.LABEL)}
            </ul>
        </div>
        );
    }

    const getFaqChange = (faqChanges: any[]) => {
        if (!faqChanges.length) {
            return;
        }
        return (
            <div className='phaseBlockCol'>
                <ul className='phaseInfo'>
                    <li>FAQs</li>
                </ul>
                {faqChanges.map((change: any, index: number) =>
                    <ul className='phaseList'>
                        <li>
                            <h2 className='phaseTitle'>Question {index + 1}</h2>
                            <div className='paraSection'>
                                <span className='iconCol'><img src='/assets/svg/course-plan-request/question-ic.svg' alt='Question' /></span>
                                <p>{change.proposedChange.question}</p>
                            </div>
                            <p className='otherInfo'>Previously Question {index + 1} : {change.currentValue.question}</p>

                            <h2 className='phaseSubTitle'>Answer</h2>
                            <div className='paraSection'>
                                <span className='iconCol'><img src='/assets/svg/course-plan-request/syllabus-ic.svg' alt='Syllabus Icon' /></span>
                                <p>{change.proposedChange.answer}</p>
                            </div>
                            <p className='otherInfo'>Previously Answer : {change.currentValue.answer}</p>
                        </li>
                    </ul>
                )}
            </div>);
    }

    const getMetaTitleChanges = (change: any) => {
        if (!change || change.changeType !== CHANGE_TYPE.META_TITLE) {
            return;
        }
        return (<li>
            <h2 className='phaseTitle'>Meta Title</h2>
            <div className='paraSection'>
                <span className='iconCol'><img src='/assets/svg/course-plan-request/checklist-ic.svg' alt='Checklist' /></span>
                <p>{change.proposedChange}</p>
            </div>
            <p className='otherInfo'>{change.currentValue}</p>
        </li>);
    }

    const getMetaKeywordChange = (change: any) => {
        if (!change || change.changeType !== CHANGE_TYPE.META_KEYWORD) {
            return;
        }
        return (<li>
            <h2 className='phaseTitle'>Meta Keywords</h2>
            <div className='paraSection'>
                <span className='iconCol'><img src='/assets/svg/course-plan-request/checklist-keyword-ic.svg' alt='Checklist Keyword' /></span>
                <p>{change.proposedChange}</p>
            </div>
            <p className='otherInfo'>{change.currentValue}</p>
        </li>);
    }
    const getMetaDescriptionChanges = (change: any) => {
        if (!change || change.changeType !== CHANGE_TYPE.META_DESCRIPTION) {
            return;
        }
        return (<li>
            <h2 className='phaseTitle'>Meta Description</h2>
            <div className='paraSection'>
                <span className='iconCol'><img src='/assets/svg/course-plan-request/checklist-description-ic.svg' alt='Checklist Description' /></span>
                <p>{change.proposedChange}</p>
            </div>
            <p className='otherInfo'>{change.currentValue}</p>
        </li>);
    }


    const getSeoChanges = (seoChanges: any[]) => {
        if (!seoChanges.length) {
            return;
        }
        const metaTitleChanges = seoChanges.find(change => change.changeType === CHANGE_TYPE.META_TITLE);
        const metaKeywordChanges = seoChanges.find(change => change.changeType === CHANGE_TYPE.META_KEYWORD);
        const metaDescriptionChanges = seoChanges.find(change => change.changeType === CHANGE_TYPE.META_DESCRIPTION);

        return (<div className='phaseBlockCol'>
            <ul className='phaseInfo'>
                <li>Course SEO *</li>
            </ul>
            <ul className='phaseList'>
                {getMetaTitleChanges(metaTitleChanges)}
                {getMetaKeywordChange(metaKeywordChanges)}
                {getMetaDescriptionChanges(metaDescriptionChanges)}
            </ul>
        </div>);
    }

    const getAdvanceChanges = () => {
        const advanceChange = coursePlanChanges[REQUEST_CHANGES.ADVANCE] || [];
        const changeType: any = {
            [PACKAGE_CHANGE_TYPE.SEO]: [],
            [PACKAGE_CHANGE_TYPE.FAQ]: [],
            [PACKAGE_CHANGE_TYPE.GENERAL_SETTING]: [],
        };

        advanceChange.forEach((change: any) => {
            changeType[change.type].push(change);
        });

        return (<div className={cx('coursePlanRequestContent', { 'active': activeTab === COURSE_CHANGE_TAB.ADVANCE_SETTINGS })}>
            <h1 className='mainHeading'><strong>{advanceChange.length}</strong> new requests</h1>
            <div className='phaseBlockSection'>
                {getGeneralSetting(changeType.generalSetting)}
                {getFaqChange(changeType.faq)}
                {getSeoChanges(changeType.seo)}
            </div>
        </div>);
    }

    const getAddChange = () => {
        const addChanges = coursePlanChanges[REQUEST_CHANGES.ADD] || [];
        return (<div className={cx('coursePlanRequestContent', { 'active': activeTab === COURSE_CHANGE_TAB.ADDED })}>
            <h1 className='mainHeading'><strong>{addChanges.length}</strong> new requests</h1>
            {addChanges.map((change: any) => {
                const path = change.newPath;
                const addedContent = path.content && path.content.name;
                return <div>
                    <div className='phaseBlockSection'>
                        <div className='phaseBlockCol'>
                            <ul className='phaseInfo'>
                                <li className='whiteSpaceNoWrap'>Phase: <strong>{path.phase && path.phase.phaseNo}</strong></li>
                                <li className='whiteSpaceNoWrap'>Week: <strong>{path.week && path.week.weekNo}</strong></li>
                                <li>{path.subject && path.subject.subjectName}</li>
                                <li>{path.chapter && path.chapter.chapterName}</li>
                                <li>{path.concept && path.concept.conceptName}</li>
                            </ul>
                            <div className='phaseList'>
                                <div className='removedParaSection'>
                                    {addedContent && <span className='iconCol'><img src={getImageSource(change.entityType)} alt='Content Type' /></span>}
                                    <p>{getLastAddedContent(path)}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            })
            }
        </div>);
    }

    const getRemoveChange = () => {
        const oldChanges = coursePlanChanges[REQUEST_CHANGES.REMOVE] || [];
        return (<div className={cx('coursePlanRequestContent', { 'active': activeTab === COURSE_CHANGE_TAB.REMOVED })}>
            <h1 className='mainHeading'><strong>{oldChanges.length}</strong> new requests</h1>
            {
                oldChanges.map((change: any) => {
                    const path = change.oldPath;
                    return <div>
                        <div className='phaseBlockSection'>
                            <div className='phaseBlockCol'>
                                <ul className='phaseInfo'>
                                    <li className='whiteSpaceNoWrap'>Phase: <strong>{path.phase && path.phase.phaseNo}</strong></li>
                                    <li className='whiteSpaceNoWrap'>Week: <strong>{path.week && path.week.weekNo}</strong></li>
                                    <li>{path.subject && path.subject.subjectName}</li>
                                    <li>{path.chapter && path.chapter.chapterName}</li>
                                    <li>{path.concept && path.concept.conceptName}</li>
                                </ul>
                                <div className='phaseList'>
                                    <div className='removedParaSection'>
                                        <span className='iconCol'><img src={getImageSource(change.entityType)} alt='Content Type' /></span>
                                        <p>{getLastAddedContent(path)}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                })
            }
        </div>);
    }

    const getOtherChanges = () => {
        const otherChanges = coursePlanChanges[REQUEST_CHANGES.OTHER] || [];
        const basicInfo = otherChanges.filter((change: any) => change.type === PACKAGE_CHANGE_TYPE.BASIC_INFO);
        const coursePlan = otherChanges.filter((change: any) => change.type === PACKAGE_CHANGE_TYPE.COURSE_INFO);

        return (<div className={cx('coursePlanRequestContent', { 'active': activeTab === COURSE_CHANGE_TAB.OTHER_CHANGES })}>
            <h1 className='mainHeading'><strong>{otherChanges.length}</strong> new requests</h1>
            <div className='phaseBlockSection'>
                {!!basicInfo.length && <div className='phaseBlockCol'>
                    <ul className='phaseInfo'>
                        <li>Basic info</li>
                    </ul>
                    <ul className='phaseList'>
                        {basicInfo.map((change: any) =>
                            getBasicChange(change)
                        )}
                    </ul>
                </div>}
                {!!coursePlan.length && <div className='phaseBlockCol'>
                    <ul className='phaseInfo'>
                        <li>Course plan</li>
                    </ul>
                    <ul className='phaseList'>
                        {
                            coursePlan.map((change: any) =>
                                getCoursePlanChange(change)
                            )
                        }
                    </ul>
                </div>}
            </div>
        </div>);
    }

    return (
        <>
            <div className='pageHeading'>
                <h2> <img src="/assets/svg/left-arrow.svg" alt="Back Arrow" onClick={() => goBack()} />View Change Summary</h2>
            </div>
            <div className='viewHistory'>
                <ul className='coursePlanRequestTab'>
                    {COURSE_CHANGE.map((courseChange, tabIndex) =>
                    (!!((coursePlanChanges[changesKeys[tabIndex]] || []).length) &&
                        <li className={cx({ 'active': activeTab === tabIndex })} onClick={() => handleTabClick(tabIndex)} key={tabIndex}><span>{courseChange}</span></li>)

                    )}
                </ul>
                {getAddChange()}
                {getRemoveChange()}
                {getOtherChanges()}
                {getReorderChanges()}
                {getAdvanceChanges()}
                {getDateChanges()}
            </div>
        </>
    );
};
export default HistoryDetail;